import Vue from 'vue'

// Эти директивы предполагают что у компонента есть примесь Screen и использует show / hide поведение из Screen

Vue.directive('window', {

	bind(el, binding, vnode) {

		// Этот метод срабатывает в момент показа окна

		let component = vnode.context,
			rootEl = el,
			cardEl = el.querySelector('.card');

		cardEl._dragCoords = {x: 0, y: 0};
		cardEl._scale = 1;

		// Активируем плавный показ и исчезновение окон
		WindowDirective.handleSmoothAppearance(component, rootEl, cardEl);

		// Логика закрытия окна
		WindowDirective.handleCloseAppearance(component, rootEl, cardEl);

		// Логика перемещения окна
		WindowDirective.handleDragAppearance(component, rootEl, cardEl);

	},

	unbind(el, binding, vnode) {

		let component = vnode.context,
			rootEl = el,
			cardEl = el.querySelector('.card');

		rootEl.unwatchHiding();

		rootEl.removeEventListener('click', rootEl._windowCloseHandler);
		cardEl.removeEventListener('click', cardEl._windowCardStopHandler);

	}

});

let WindowDirective = {

	windowsStack: [],

	// Делаем плавный показ и исчезновение окон
	handleSmoothAppearance(component, rootEl, cardEl) {

		rootEl.style.transition = "all .3s, opacity 0.2s";
		cardEl.style.transition = "scale .2s";

		rootEl.unwatchHiding = component.$watch('metadata.hiding', () => {

			this.toggleShowing(component, rootEl, cardEl);

		});

		// При показе компонента hiding должен быть true - то есть окно скрыто
		Vue.set(component.metadata, 'hiding', true);

		rootEl.style.zIndex = Layout.windowsZIndex++; // Устанавливаем каждое новое открывающееся окно сверху остальных

		// Из-за if в первом элементе всех окон html элементы создаются заново каждый раз при новом показе окна и нету стилей по умолчанию.
		// Поэтому приходится тут делать processHide
		// Замена v-if на v-show у всех окон приводит к череде ошибок и даже если их исправить то получится,
		// что все окна будут рендерится и их DOM будет создаваться в начале запуска дашборда, что приведет к тормозам
		this.processHide(component, rootEl, cardEl);

		// В следующий тик ставим ему hiding false, чтобы начать анимированный показ окна
		setTimeout(() => {

			component.$nextTick(() => { Vue.set(component.metadata, 'hiding', false); });

		}, 30);

	},

	toggleShowing(component, rootEl, cardEl) {

		if (component.metadata.hiding) this.processHide(component, rootEl, cardEl);
		else this.processShow(component, rootEl, cardEl);

	},

	processShow(component, rootEl, cardEl) {

		// Запомним порядок открывания окон в стек
		WindowDirective.windowsStack.push({component, rootEl, cardEl});

		rootEl.style.opacity = 1;
		rootEl.style.pointerEvents = 'all';
		cardEl.style.scale = 1;

	},

	processHide(component, rootEl, cardEl) {

		// Если последнее окно в стеке открытых окон является переданным окном в этот метод - удалям его из стека
		let window = WindowDirective.windowsStack.at(-1);
		if (window && window.component === component) WindowDirective.windowsStack.pop();

		rootEl.style.opacity = 0;
		rootEl.style.pointerEvents = 'none'; // Чтобы быстро можно было кликами в свободное место закрывать несколько окон подряд, а не ждать анимации закрытия каждого из них
		cardEl.style.scale = 0.9;

	},

	// Логика перемещения окна
	handleDragAppearance(component, rootEl, cardEl) {

		let headEl = cardEl.querySelector('.card-header');

		headEl.style.cursor = 'default';

		headEl.addEventListener("mousedown", (e) => {

			this.startDrag(component, cardEl, headEl, e);

		});

	},

	startDrag(component, cardEl, headEl, e) {

		this.dragComponent = component;
		this.downCoords = {x: e.clientX, y: e.clientY};
		this.cardCoords = {x: cardEl._dragCoords.x, y: cardEl._dragCoords.y};
		this.dragActive = false;
		this.dragCardEl = cardEl;
		this.dragHeadEl = headEl;

	},

	processDrag(e) {

		if (this.dragComponent) {

			if (this.dragActive) {

				this.dragCardEl._dragCoords = {x: this.cardCoords.x + (e.clientX - this.downCoords.x), y: this.cardCoords.y + (e.clientY - this.downCoords.y)};

				this.updateCardTransform(this.dragCardEl)

			} else {

				let dist = Math.sqrt(Math.pow(e.clientX - this.downCoords.x, 2) + Math.pow(e.clientY - this.downCoords.y, 2));

				if (dist > 5) {
					this.dragActive = true;
					this.dragHeadEl.style.cursor = 'move';
				}

			}

		}

	},

	stopDrag() {

		if (this.dragComponent) {

			this.dragComponent = null;

			this.dragHeadEl.style.cursor = 'default';

		}

	},

	updateCardTransform(cardEl) {

		cardEl.style.transform = `translate(${cardEl._dragCoords.x}px, ${cardEl._dragCoords.y}px) scale(${cardEl._scale})`;

	},

	// Логика закрытия окна
	handleCloseAppearance(component, rootEl, cardEl) {

		// Закрытие по клику в любом месте
		rootEl._windowCloseHandler = () => { WindowDirective.close(component); };
		rootEl.addEventListener('click', rootEl._windowCloseHandler);

		cardEl._windowCardStopHandler = (e) => { e.stopPropagation(); };
		cardEl.addEventListener('click', cardEl._windowCardStopHandler);

		// Создаём метод для программного закрытия окна
		component.closeWindow = () => { WindowDirective.close(component); };

	},

	close(component) {

		Vue.set(component.metadata, 'hiding', true);

		setTimeout(() => {

			component.hide();

		}, 200);

	}

};

window.addEventListener("mousemove", (e) => {

	WindowDirective.processDrag(e);

});

window.addEventListener("mouseup", (e) => {

	WindowDirective.stopDrag();

});

document.addEventListener('keydown', (e) => {

    if (e.key === 'Escape') {

    	// Закрываем последнее открытое окно
    	let window = WindowDirective.windowsStack.pop();
    	if (window) WindowDirective.close(window.component);

    }

});
